import type { AppLocale } from '@/i18n/locales'
import { defaultBuffPreferences, type BuffSnapshot } from './types'

/** Classic buffs: Bless, Sharp Eyes, Maple Warrior. */
export const PREVIEW_BUFF_ICONS = {
  bless: '/buff-preview/bless.png',
  sharpEyes: '/buff-preview/sharp-eyes.png',
  mapleWarrior: '/buff-preview/maple-warrior.png',
} as const

/** Three real skill icons so every skin preview shows its buff anchor. */
export function previewBuffSnapshot(locale: AppLocale): BuffSnapshot {
  const now = Date.now()
  const fresh = { enabled: true, upperSeconds: 180, capturedAt: now, cycle: 1, reason: 'preview', visual: true, validUntil: now + 60_000, numberValidUntil: now + 60_000 }
  return {
    state: 'running', locale, now, alerts: [], layout: defaultBuffPreferences().layout,
    items: [
      { ...fresh, id: 'preview-bless', name: '祝福', imageUrl: PREVIEW_BUFF_ICONS.bless, presence: 'present', seconds: 128, nearing: false, estimatedEndAt: now + 128_000 },
      { ...fresh, id: 'preview-sharp-eyes', name: '火眼晶晶', imageUrl: PREVIEW_BUFF_ICONS.sharpEyes, presence: 'present', seconds: 8, nearing: true, estimatedEndAt: now + 8_000 },
      { ...fresh, id: 'preview-maple-warrior', name: '冒险岛勇士', imageUrl: PREVIEW_BUFF_ICONS.mapleWarrior, presence: 'missing', seconds: null, nearing: false },
    ],
  }
}
